(function() { window.GUID_15c74b5c_1bb4_4c5a_a993_f43f947f3331 = { getGuid: function() { return "15c74b5c-1bb4-4c5a-a993-f43f947f3331"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-game-history-against",
                        callback: (accordion, e) => {
                            var _a;
                            const $eventGameHeaders = accordion.$Content.find(".event-games__header");
                            if ($eventGameHeaders.length > 0) {
                                $eventGameHeaders.each((index, element) => {
                                    const $eventGameHeader = $(element);
                                    accordion.SetContentSticky($eventGameHeader);
                                });
                            }
                            const $emptyStateElement = accordion.$Content.find(`#GameHistoryAgainstSectionViewModelNoData-${accordion.ContentId}`);
                            if ($emptyStateElement.length) {
                                const $gameTypeNameInput = accordion.$Content.find(`#GameHistoryAgainstSectionViewModelGameTypeName-${accordion.ContentId}`);
                                const gameTypeName = (_a = $gameTypeNameInput.val()) !== null && _a !== void 0 ? _a : "";
                                if (gameTypeName.trim() === "") {
                                    $emptyStateElement.text(JSRess.These2OpponentsHaveNeverPlayedAgainstEachOther);
                                }
                                else {
                                    $emptyStateElement.html(CS.Helper.formatString(JSRess.These2OpponentsHaveNeverPlayedAgainstEachOtherInX, gameTypeName));
                                }
                                return;
                            }
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=game-history-against.js.map
